/**
 * Daily avg response time (PENDING → ACCEPTED) line chart.
 *
 * Recharts AreaChart so we get the gradient fill underneath, with a
 * tooltip that formats the value back into Xm Ys.
 */
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from "recharts";

import ChartCard from "../ChartCard/ChartCard";
import {
  CHART_PALETTE,
  formatDateShort,
  formatSec
} from "../../../../../constants/analytics.constants";

const TooltipBox = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  return (
    <div
      style={{
        background: CHART_PALETTE.ink,
        color: "#fff",
        fontSize: 11,
        padding: "6px 8px",
        borderRadius: 6,
        boxShadow: "0px 2px 4px rgba(0,0,0,0.25)"
      }}
    >
      <div style={{ color: "#A9A7BD", fontSize: 10 }}>
        {formatDateShort(label)}
      </div>
      <div style={{ fontWeight: 600, fontSize: 12, marginTop: 1 }}>
        {formatSec(payload[0].value)}
      </div>
    </div>
  );
};

const ResponseTimeChart = ({ data = [] }) => (
  <ChartCard
    title="Response time trend"
    subtitle="Avg seconds from PENDING → ACCEPTED"
    action={
      <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
        <i
          style={{
            width: 8,
            height: 8,
            borderRadius: "50%",
            background: CHART_PALETTE.ink,
            display: "inline-block"
          }}
        />
        Avg response
      </span>
    }
  >
    {data.length === 0 ? (
      <div style={{ flex: 1, display: "grid", placeItems: "center", color: "#8E8E8E", fontSize: 12 }}>
        No data for this range
      </div>
    ) : (
      <ResponsiveContainer width="100%" height={240}>
        <AreaChart data={data}>
          <defs>
            <linearGradient id="rt-fill" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={CHART_PALETTE.ink} stopOpacity={0.18} />
              <stop offset="100%" stopColor={CHART_PALETTE.ink} stopOpacity={0} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 4" stroke={CHART_PALETTE.inkLine} vertical={false} />
          <XAxis
            dataKey="date"
            tickFormatter={formatDateShort}
            tick={{ fontSize: 10, fill: CHART_PALETTE.axis }}
            axisLine={false}
            tickLine={false}
            interval="preserveStartEnd"
          />
          <YAxis
            tickFormatter={formatSec}
            tick={{ fontSize: 10, fill: CHART_PALETTE.axis }}
            axisLine={false}
            tickLine={false}
            width={60}
          />
          <Tooltip content={<TooltipBox />} />
          <Area
            type="monotone"
            dataKey="avgSeconds"
            stroke={CHART_PALETTE.ink}
            strokeWidth={2}
            fill="url(#rt-fill)"
            dot={{ r: 2.5, stroke: CHART_PALETTE.ink, fill: "#fff" }}
            activeDot={{ r: 4, stroke: CHART_PALETTE.ink, fill: "#fff" }}
          />
        </AreaChart>
      </ResponsiveContainer>
    )}
  </ChartCard>
);

export default ResponseTimeChart;
